// extracted by mini-css-extract-plugin
export default {"root":"root-nnAtXNlY","translucent":"translucent-yFEzW3A1","opaque":"opaque-bbesbw5D","card":"card-yGyflDF7"};